const ENV_ENVIRONMENT_BASE_URL_API = 'https://api-service.sukienthongminh.com/api';

const ENV_ENVIRONMENT_awsKeys = {
  bucket: 'smart-events-pro',
  accessKeyID: 'AKIAS37NMZ7DEK2GO4Y3',
  secretKeyID: 'mX+K5S7jUDDP5E3y0V4K1VA88xQWaO1jExpz8aNh',
  endpoint: 'https://smart-events-pro.s3.ap-southeast-1.amazonaws.com/',
  region: 'ap-southeast-1',
};

export const ENVIRONMENT_BASE_URL_API = ENV_ENVIRONMENT_BASE_URL_API;
export const ENVIRONMENT_awsKeys = ENV_ENVIRONMENT_awsKeys;

export const ENV_PUBLIC_API = 'https://builder.matbao.ws/api';

export const MAP_KEY = 'AIzaSyB8AA2t0_q_qz388TTiR6lUAXkq00a18T8';
